import { isArray, isBoolean } from 'util';

import * as RegionsActions from '../actions/regions';
import * as GroupsActions from '../actions/groups';
import * as QueryActions from '../actions/query';
import * as TabsActions from '../../../xena-tabs/state-management/actions/tabs';
import * as SettingsActions from '../actions/settings';

import { RegionsItem } from '../../shared/models/regions-response.model';
import { Query } from '../../shared/models/query/query.model';
import { InitialState as InitialTabState } from '../../../xena-tabs/state-management/reducers/tabs';


export interface StateObject {
	tab: number;
	selected: boolean;
	loading: boolean;
	result: Array<RegionsItem>;
}

export type State = Array<StateObject>;

export const initialState: State = [{
	tab: InitialTabState[0].id,
	selected: InitialTabState[0].selected,
	loading: false,
	result: []
}];

export function reducer(state: State = initialState, action: RegionsActions.All | TabsActions.All | QueryActions.All | SettingsActions.All | GroupsActions.All): State {
	switch (action.type) {
		case RegionsActions.INIT_REGION_TABS:
			return action.payload.map((tab, index) => ({
				tab: tab.id,
				selected: tab.selected,
				loading: state[index] && isBoolean(state[index].loading) ? state[index].loading : initialState[0].loading,
				result: state[index] && isArray(state[index].result) ? state[index].result : initialState[0].result
			}));

		case TabsActions.ADD_TAB:
			return state.concat({tab: action.payload.id, selected: false, loading: false, result: []});

		case TabsActions.SELECT_TAB:
			return state.map(stateObj => ({...stateObj, selected: stateObj.tab === action.payload.id}));

		case TabsActions.REMOVE_TAB:
			if (state.length === 1) {
				return state;
			}

			const tabToRemove = state.find(stateObj => stateObj.tab === action.payload.id);
			const newState = state.filter(stateObj => stateObj.tab !== action.payload.id);

			if (tabToRemove.selected) {
				newState[0].selected = true;
			}

			return newState;

		case RegionsActions.LOAD_REGIONS_SUCCESS:
			return state.map((stateObj: StateObject) => Object.assign({}, stateObj, (stateObj.selected ? {result: action.payload.data, loading: false} : {})));

		case QueryActions.SUBMIT_QUERY:
			return state.map(stateObj => ({...stateObj, ...(stateObj.selected ? {result: [], loading: true} : {})}));

		case GroupsActions.LOAD_GROUPS_SUCCESS:
			return state.map(stateObj => ({...stateObj, ...(stateObj.selected ? { ...stateObj, loading: false } : {})}));

		case RegionsActions.LOAD_REGIONS_ERROR:
		case QueryActions.RESET_QUERY:
		case SettingsActions.SWITCH_SEARCH_TYPE:
			return state.map(stateObj => ({...stateObj, ...(stateObj.selected ? {result: [], loading: false} : {})}));

		default:
			return state;
	}
}

/**
 * helper selector functions
 */
export const GetAll = (s: State): Array<RegionsItem> => s.find(st => st.selected).result;
export const GetSelected = (s: State): StateObject => s.find(st => st.selected);



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/regions.ts